// extracted by mini-css-extract-plugin
module.exports = {"containerWrapper":"Wfo7U","outer":"_3GS8s","heading":"_3FV_j","subHeading":"_3lei3","bottomButtonWrap":"SIMRI"};